import {
    Component,
    EventEmitter,
    Inject,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
  } from '@angular/core';
  import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
  import { MAT_DIALOG_DATA } from '@angular/material/dialog';
  import { UserUtil } from '../../../../data/utils/user.utils';
  import { Show } from '../../models/show.interface';
  import { CreateShowDto, UpdateShowDto } from '../../dtos';
  import { FileService } from 'src/app/data/services/file.service';
  import { FileDto } from 'src/app/data/models/dto/file.dto';
  import { BookingParamsDto } from '../../dtos/booking-params.dto';
  import { BookingsService } from '../../services/bookings.service';
  import { SimpleUserDto } from 'src/app/data/models/dto/simple-user.dto';
import { Booking } from '../../models/booking.interface';
import { Seat } from '../../models';
import { SearchBarComponent } from 'src/app/ui/components/search-bar/search-bar.component';
import { BookingStatus } from '../../enums/booking-status.enum';
  
  @Component({
    selector: 'app-bookings-report',
    templateUrl: './bookings-report.component.html',
    styleUrls: ['./bookings-report.component.scss'],
    encapsulation: ViewEncapsulation.None,
  })
  export class BookingsReportComponent implements OnInit {
    bookings: any[] = []
    bookingsFiltered: any[] = []
    displayedColumns: string[] = ['name','status','seats']

    profilesFilter: string[] = []
    bookingStatusFilter?: BookingStatus
    disableResetFilters: boolean = true 
    selectedIdsProfiles: string[] = []
  
    get isUpdate() {
      return this.show?.id ? true : false;
    }
  
    show?: Show = this.data.show;
  
    today: Date = new Date();
  
    disabled = true;
  
    user: SimpleUserDto | undefined
  
    constructor(
      private readonly fb: FormBuilder,
      private readonly userUtil: UserUtil,
      private readonly fileService: FileService,
      private readonly bookingService: BookingsService,
      @Inject(MAT_DIALOG_DATA)
      private readonly data: {
        show?: Show;
      },
    ) { }
  
    async ngOnInit() {
      this.getAllBookings()
    }
  
    private get schools() {
      return this.userUtil.getSchools();
    }
  
    private buildParams(
      idShow?:string,
      idsProfiles?: string[],
      status?: BookingStatus
    ): BookingParamsDto{
      return {
        idShow: idShow,
        status: status
      }
    }
  
    async getAllBookings(){
      const params = this.buildParams(this.show?.id,this.profilesFilter,this.bookingStatusFilter);
      const response = await this.bookingService.findAll(params).toPromise();
      this.bookings = response
      this.bookingsFiltered = this.bookings
    }
  
    async handleChangeStatus(change?: string) {
      if(change===undefined){
        this.bookingStatusFilter = undefined
      } else {
        this.bookingStatusFilter = change === BookingStatus.BOOKED_SUCCESSFULLY ? BookingStatus.BOOKED_SUCCESSFULLY : BookingStatus.CANCELED
      }
      this.resetFiltersStatus()
      this.getAllBookings()
    }

    resetFilters(){
      if(
        this.profilesFilter.length > 0 ||
        this.bookingStatusFilter !== undefined
      ){
        this.profilesFilter = []
        this.bookingStatusFilter = undefined
      }
      this.disableResetFilters = true
      this.getAllBookings()
    }

    resetFiltersStatus(){
      this.disableResetFilters =
        this.profilesFilter.length == 0 &&
        this.bookingStatusFilter === undefined
    }

    filterText(text: string){
      if(text===''){
        this.bookingsFiltered = this.bookings
        return
      }
      this.bookingsFiltered = []
      this.bookings.forEach(booking => {
        if(booking.user!==null && booking.user!==undefined){
          const fullName = booking.user.firstName + ' ' + booking.user.lastName
          if(fullName.toLowerCase().indexOf(text.toLowerCase())!==-1) this.bookingsFiltered.push(booking)
        }
        if(booking.child!==null && booking.child!==undefined){
          const fullName = booking.child.firstName + ' ' + booking.child.lastName
          if(fullName.toLowerCase().indexOf(text.toLowerCase())!==-1) this.bookingsFiltered.push(booking)
        }
      })
    }

    getName(booking: any){
      if(booking.child){
        return booking.child.firstName + ' ' + booking.child.lastName
      }else {
        return booking.user.firstName + ' ' + booking.user.lastName
      }
    }

    concatSeatsString(seats: Seat[]){
      let concatSeats: string = ''
      seats.forEach(seat => {
        concatSeats += seat.row + seat.column.toString()+','
      });
      return concatSeats.substring(0, concatSeats.length-1)
    }
  
    //#endregion
  }
  